import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { VoteContainer } from '../VoteContainer';
import * as styles from './FullTextReviewExcludeReasonPanel.module.scss';
import { Inline } from 'components/layout';
import { Select, SelectProps, Button, FormLabel, Text } from 'components/core';

// To avoid change the Select structure and make it accepts 'ref'
const SelectWithRef = Select as React.ForwardRefExoticComponent<
  SelectProps & React.RefAttributes<HTMLSelectElement>
>;

type ExclusionOption = {
  id: string | number;
  reason: string;
};

type Props = {
  exclusionReason: string;
  onChangeExclusionReason: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  showExcludeReasonsRequired: boolean;
  onConfirmExclude: () => void;
  onCancelExclude: () => void;
  excludeReasonSelectRef: React.RefObject<HTMLSelectElement>;
  exclusionsOptions: ExclusionOption[];
  isExcludeSubmitting?: boolean;
};

const FullTextReviewExcludeReasonPanel = ({
  exclusionReason,
  onChangeExclusionReason,
  showExcludeReasonsRequired,
  onConfirmExclude,
  onCancelExclude,
  excludeReasonSelectRef,
  exclusionsOptions,
  isExcludeSubmitting,
}: Props) => {
  const selectId = uuidv4();
  const requiredTextId = uuidv4();

  return (
    <VoteContainer className={styles.excludeReasonContainer}>
      <FormLabel size="sm" htmlFor={selectId}>
        What is the reason for excluding this study?
      </FormLabel>

      <SelectWithRef
        id={selectId}
        ref={excludeReasonSelectRef}
        aria-describedby={
          showExcludeReasonsRequired ? requiredTextId : undefined
        }
        value={exclusionReason}
        onChange={onChangeExclusionReason}
        className={showExcludeReasonsRequired ? styles.selectError : ''}
      >
        {!exclusionReason && (
          <option value="" disabled>
            Select...
          </option>
        )}

        {exclusionsOptions.map((r) => (
          <option key={r.id.toString()} value={r.reason.trim()}>
            {r.reason.trim()}
          </option>
        ))}
      </SelectWithRef>

      {showExcludeReasonsRequired && (
        <Text id={requiredTextId} variant="danger" size="xs">
          Exclusion reason is required
        </Text>
      )}

      <Inline alignX="center" spacing={2}>
        <Button
          type="brand"
          size="sm"
          variant="solid"
          onClick={onConfirmExclude}
          className={styles.actionButton}
          disabled={isExcludeSubmitting}
          isLoading={!!isExcludeSubmitting}
        >
          Confirm
        </Button>
        <Button
          type="neutral"
          size="sm"
          variant="outline"
          onClick={onCancelExclude}
          className={styles.actionButton}
        >
          Cancel
        </Button>
      </Inline>
    </VoteContainer>
  );
};

export default FullTextReviewExcludeReasonPanel;
